import type { AgentTool, AgentToolPack } from "@jugl-web/rest-api";

// Tool ids enabled for the Shopify pack when a Shopify store is connected
// (matches the backend agent-config doc and the legacy IntegrationToolsSection
// list).
export const SHOPIFY_PACK_TOOL_IDS = [
  "list_products",
  "add_to_cart",
  "remove_from_cart",
  "view_cart",
  "checkout",
  "get_customer_order_history",
];

export const buildIntegrationAgentTool = (args: {
  pack: AgentToolPack;
  connectionId: string;
  tools: string[];
}): AgentTool => ({
  pack: args.pack,
  connection_id: args.connectionId,
  tools: args.tools,
  params: {},
});
